module.exports = __webpack_public_path__ + "static/img/vocPlacard.8bc9210.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vocPlacard.png
// module id = 147
// module chunks = 1